import { Link } from "react-router-dom";
import { articleList } from "@/mocks/articles";

export default function ArticleCenter() {
  return (
    <section id="guides" className="py-16 md:py-24 bg-accent-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 bg-white rounded-full text-xs text-accent-700 font-medium uppercase tracking-wider">
            Latest Guides
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mt-4 leading-tight">
            ACBuy Spreadsheet
            <br />
            <span className="text-accent-600">SEO Resources</span>
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-[600px] leading-relaxed">
            In-depth guides and resources to help you master the ACBuySpreadsheet system. Learn how to track orders, optimize your buying workflow, and get the most out of your spreadsheet tools.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {/* Featured main guide card - larger */}
          <Link
            to="/acbuyspreadsheet-guide"
            className="group bg-white rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1 sm:col-span-2 lg:col-span-2 xl:col-span-2 block"
          >
            <div className="aspect-[16/7] w-full overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Comprehensive%20guidebook%20concept%20on%20modern%20laptop%20screen%20with%20spreadsheet%20interface%20and%20organized%20data%20tables%20visible%2C%20warm%20cream%20desk%20background%20with%20soft%20natural%20window%20light%2C%20scandinavian%20minimalist%20workspace%20with%20plant%20and%20coffee%2C%20clean%20professional%20atmosphere%2C%20soft%20gentle%20shadows%2C%20bright%20airy%20tones%2C%20editorial%20photography%20style&width=800&height=350&seq=article-featured-main-00&orientation=landscape"
                alt="Complete ACBuySpreadsheet Guide"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                loading="lazy"
              />
            </div>
            <div className="p-5 md:p-6">
              <div className="flex items-center gap-2 mb-2">
                <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-book-open-line text-accent-600 text-sm"></i>
                  </span>
                </span>
                <span className="text-xs text-accent-600 font-medium">Featured Guide</span>
              </div>
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors">
                Complete ACBuy Spreadsheet Guide (2026)
              </h3>
              <p className="text-sm text-foreground-400 mt-2 leading-relaxed">
                Everything you need to know about the acbuy spreadsheet system. A comprehensive walkthrough for beginners and advanced users alike.
              </p>
              <span className="inline-flex items-center gap-1 text-sm text-accent-600 font-medium mt-4 group-hover:gap-2 transition-all">
                Read Guide
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </span>
            </div>
          </Link>

          {/* 9 new article cards */}
          {articleList.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-white rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1 block"
            >
              <div className="aspect-[3/2] w-full overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="text-xs text-foreground-400">{article.readTime}</span>
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mt-1.5 group-hover:text-primary-500 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-2 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-xs text-accent-600 font-medium mt-3 group-hover:gap-1.5 transition-all">
                  Read Article
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-[10px]"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}